import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import ShelfAddTitleButton from '../ShelfAddTitleButton';
import ShelfFindAvailableTitlesButton from '../ShelfFindAvailableTitlesButton';
import ShelfAvailabilityWarning from '../ShelfAvailabilityWarning';

import './ShelfTitleBar.scss';

export default function ShelfTitleBar({
  owner,
  shelfActions,
  currentShelfName,
  currentUserShelves,
  currentShelfCount,
  shelfTransactions
}) {
  if (owner.get('loggedIn')) {
    return (
      <div className="cp-shelf-title-bar">
        <ShelfAddTitleButton
          shelfActions={shelfActions}
          currentShelfName={currentShelfName}
          currentUserShelves={currentUserShelves}
          shelfTransactions={shelfTransactions}
          ownerId={owner.get('id')}
        />
        <ShelfFindAvailableTitlesButton currentShelfName={currentShelfName} />
        <ShelfAvailabilityWarning shelfCount={currentShelfCount} />
      </div>
    );
  }

  return null;
}

ShelfTitleBar.propTypes = {
  owner: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  currentShelfName: PropTypes.string.isRequired,
  currentUserShelves: ImmutablePropTypes.map.isRequired,
  currentShelfCount: PropTypes.number.isRequired
};
